// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qc_a","ListOfForumsRight__brandDaysPosts":"qc_b bhi_su"};